module.exports = __webpack_public_path__ + "img/cancel.db2ce350.png";